module.exports = __webpack_public_path__ + "static/img/sb.72fc0629.svg";